// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import "./assets/css/common.css"
import axios from 'axios'
import NutUI from '@nutui/nutui';
import Vant from 'vant';
import 'vant/lib/index.css';
import '@nutui/nutui/dist/nutui.css';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import VueTianditu from "vue-tianditu";
import BaiduMap from 'vue-baidu-map';
Vue.use(BaiduMap, {
    /* Visit http://lbsyun.baidu.com/apiconsole/key for details about app key. */
    ak: 'EGdGnxkC80iVN08qD0md03icKS1iHPAv'
})
Vue.use(VueTianditu, {
    v: "4.0", //目前只支持4.0版本
    tk: "6a38655dedfced54349a40b96586b407"
});
router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next()
})
Vue.use(ElementUI);
Vue.use(Vant);
NutUI.install(Vue);

Vue.prototype.$axios = axios
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: {
        App
    },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js